import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=4c357e11&scoped=true"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=4c357e11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c357e11",
  null
  
)

export default component.exports